/*global Modernizr, jQuery, wp, google, console */
/*jslint browser:true */

(function($) {
  'use strict';

  var saved_zip_codes = {};

  var filter_container = document.querySelector('.location-filter-container');
  if(filter_container) {
    var geocoder = new google.maps.Geocoder(),
        main_container = filter_container.parentElement,
        location_search_status = document.getElementById('location-search-status'),
        location_view_toggle_container = filter_container.previousElementSibling.querySelector('.location-views'),
        location_search_form = filter_container.querySelector('form'),
        additional_filters_trigger = document.getElementById('locations-additional-filters'),
        additional_filters_counter = additional_filters_trigger.querySelector('.count'),
        additional_filters_container = filter_container.querySelector('.filter-location-services'),
        form_reset = filter_container.querySelector('button[type="reset"]');

    location_view_toggle_container.addEventListener('click', (e) => {
      e.preventDefault();

      if(e.target.tagName.toLowerCase() === 'button') {
        location_view_toggle_container.querySelector('.active').classList.remove('active');

        main_container.classList.remove('view-list');
        main_container.classList.remove('view-map');
        main_container.classList.add('view-' + e.target.getAttribute('data-view'));

        const event = new CustomEvent('view-updated');
        document.getElementById('locations-search-' + e.target.getAttribute('data-view')).dispatchEvent(event);

        e.target.classList.add('active');

        location_search_status.innerText = 'View switched to ' + e.target.getAttribute('data-view');
      }
    });

    additional_filters_trigger.addEventListener('click', (e) => {
      e.preventDefault();

      if(additional_filters_trigger.parentElement.parentElement.classList.contains('open-additional-fields')) {
        additional_filters_trigger.setAttribute('aria-expanded', 'false');
      } else {
        additional_filters_trigger.setAttribute('aria-expanded', 'true');
      }

      additional_filters_trigger.parentElement.parentElement.classList.toggle('open-additional-fields');
    });

    additional_filters_container.addEventListener('change', (e) => {
      var checked = 0,
          checkboxes = additional_filters_container.querySelectorAll('input');

      checkboxes.forEach((checkbox) => {
        if(checkbox.checked) {
          checked++;
        }
      });

      if(checked > 0) {
        additional_filters_counter.classList.remove('hidden');
      } else {
        additional_filters_counter.classList.add('hidden');
      }

      additional_filters_counter.querySelector('span').innerText = checked;
    });

    form_reset.addEventListener('click', (e) => {
      e.preventDefault();

      location_search_form.querySelector('input[name="zip_code"]').value = '';
      location_search_form.querySelector('select[name="radius"]').value = '10';
      location_search_form.querySelector('input[name="location-type"][value="branch"]').checked = true;
      location_search_form.querySelector('.gform_fields').classList.remove('open-additional-fields');
      location_search_form.querySelectorAll('input[name="location-services[]"]').forEach((service_input) => {
        service_input.checked = false;
      });
      additional_filters_counter.classList.add('hidden');
      additional_filters_counter.querySelector('span').innerText = 0;
      document.getElementById('zip_code_data').value = '';

      location_search_form.querySelector('button[type="submit"]').disabled = true;
      form_reset.disabled = true;
      main_container.classList.remove('view-no-results');
      main_container.classList.add('view-loading');

      search_ajax();
    });

    location_search_form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if(document.getElementById('zip_code').value !== '') {
        location_search_form.querySelector('button[type="submit"]').disabled = true;
        additional_filters_trigger.parentElement.parentElement.classList.remove('open-additional-fields');
        main_container.classList.remove('view-no-results');
        main_container.classList.add('view-loading');

        if(document.getElementById('zip_code').value in saved_zip_codes) {
          document.getElementById('zip_code_data').value = JSON.stringify(saved_zip_codes[document.getElementById('zip_code').value]);
          search_ajax();
        } else {
          search_geocode();
        }
      }

      return false;
    });
  }

  function search_geocode() {
    geocoder.geocode({
      'address': document.getElementById('zip_code').value + ' Texas',
    }, function(results, status) {
        if (status === 'OK') {
          document.getElementById('zip_code_data').value = JSON.stringify(results[0].geometry.location);
          saved_zip_codes[document.getElementById('zip_code').value] = results[0].geometry.location;
          search_ajax();
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
        }
    });
  }

  function search_ajax() {
    location_search_status.innerText = 'Searching locations.';

    wp.ajax.post($(location_search_form).serializeArray())
      .done(function(response) {
        process_locations(response.locations);
      })
      .fail(function(response) {
        console.log('ERROR');
        console.log(response);
      });
  }

  function process_locations(locations) {
    location_search_form.querySelector('button[type="submit"]').disabled = false;
    form_reset.disabled = false;
    main_container.classList.remove('view-loading');

    if(locations.length === 0) {
      main_container.classList.add('view-no-results');
      return;
    }

    const event = new CustomEvent('load-locations', {detail: {locations: locations}});
    document.getElementById('locations-search-list').dispatchEvent(event);
    document.getElementById('locations-search-map').dispatchEvent(event);

    location_search_status.innerText = locations.length + ' results returned.';
  }
}(jQuery));
